module.exports = __webpack_public_path__ + "media/images/payment/security-fff0bdb6336abb72c5b837010b753111.svg";